<template>
    <div>
        <CompassTooltip
            :content="$t.__('listing.settings.ListingSettingsColumn.tooltip.can_not_hide')"
            :disabled="!column.isDefault"
            placement="top-start"
            :arrow="false"
        >
            <CompassCheckbox
                :modelValue="column.label"
                :label="column.label"
                :disabled="column.isDefault"
                :checked="column.isVisible"
                @change="$emit('checkboxChange')"
            />
        </CompassTooltip>
        <CompassTooltip
            v-if="!hasSearchQuery"
            :content="$t.__('listing.settings.ListingSettingsColumn.tooltip.can_not_move')"
            :disabled="column.isMovable"
            placement="top-start"
            :arrow="false"
        >
            <div class="listing-settings-column-item__actions">
                <div class="listing-settings-column-item__actions-order">
                    <CompassIconButton
                        :disabled="!canBeMovedUp"
                        icon="caret-up"
                        class="listing-settings-column-item__actions-order--up"
                        size="extra-small"
                        @click="$emit('mooveUp')"
                    />
                    <CompassIconButton
                        :disabled="!canBeMovedDown"
                        icon="caret-down"
                        class="listing-settings-column-item__actions-order--down"
                        size="extra-small"
                        @click="$emit('mooveDown')"
                    />
                </div>

                <CompassIcon
                    icon="drag-and-drop"
                    :type="column.isMovable ? 'primary' : 'disabled'"
                />
            </div>
        </CompassTooltip>
    </div>
</template>

<script>
export default {
    props: {
        column: {
            type: Object,
            required: true,
        },
        canBeMovedUp: {
            type: Boolean,
            default: false,
        },
        canBeMovedDown: {
            type: Boolean,
            default: false,
        },
        hasSearchQuery: {
            type: Boolean,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.listing-settings-column-item {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-2);
    border-radius: var(--spacing-0);
    background-color: var(--colors-component-background-actionable-default);
    border: 1px solid transparent;
    :deep() {
        .compass-tooltip:has(.listing-settings-column-item__actions) {
            flex-grow: 1;
            .compass-tooltip__element {
                width: 100%;
            }
        }
    }

    &--disabled:has(.listing-settings-column-item__actions) {
        cursor: not-allowed;
    }

    &__actions {
        display: flex;
        align-items: center;
        flex-grow: 1;
        justify-content: flex-end;
        gap: var(--spacing-1);

        &-order {
            display: flex;
            align-items: center;
            gap: var(--spacing-0);
        }
    }
}
</style>
